import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { Button, MenuItem, Toolbar, OverlayPanel } from '../../components/prime';
import {  UserInfoPanelComponent } from '../../components';
import styles from './index.module.scss';
import API from '../../services/api';
import { INotificacionNews } from '../../services/api/entity/model/INotificacionNews';
import Notifications from '../../components/notifications';
import { setTimeout } from 'timers';
import Security from '../../services/seguridad';

const enviroment = (window as any).app_enviroment as string;

interface IProps {
  storage?: IDataStorage;

  menu: MenuItem[];
}

interface IState {
  storage?: IDataStorage;
  
  showFloatingMenu?: boolean;
  showFullMenu?: boolean;
  
  notificaciones?: INotificacionNews[];
}

class Index extends React.Component<IProps, IState> {
  state : IState = { showFloatingMenu: false }
  UserPanelShow?: (event: React.SyntheticEvent<Element, Event>, target: EventTarget) => void = undefined;
  NotificacionPanel: OverlayPanel | null = null;

  constructor(prop:IProps) {
    super(prop);
    window.addEventListener('resize', this.resize);
  }
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.resize();
    this.checkNotificaciones(true);
  }
  static getDerivedStateFromProps = (p : IProps, s : IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;    
    return res;
  }

  resize = () => this.setState({ showFullMenu: (window.innerWidth < 767) })

  checkNotificaciones = (loop: boolean) => {
    API.ComunicacionController().Notificaciones().news({})
      .then(res => this.setState({ notificaciones: [ ...(res.data?.filter(p => !p.bajaFecha) ?? [])] }))
      .finally(() => loop && setTimeout(this.checkNotificaciones, 600000));
  }

  render() {
    const notificationUnreads = (this.state.notificaciones?.filter(p => !p.leido).length ?? 0);
    //const t = Translate.get("layoult/header", this.state.storage?.languaje);
    const logo = (!!Security.User?.cliente?.idLogo ? API.resource().getImgSrc("CLIENTES", Security.User?.cliente?.idLogo) : undefined) ??
                 (!!Security.User?.clienteN1?.idLogo ? API.resource().getImgSrc("CLIENTES", Security.User?.clienteN1?.idLogo) : undefined) ??
                 `/images/cnet-bo-${enviroment === "{{ENVIROMENT}}" ? "testing" : enviroment}.png`;

    const userAvatar = Security.User?.avatar?.url ?? Security.User?.avatar?.content ?? "/images/avatar.png";

    return (
      <div className={styles.container}>
        <div className={styles.logocontainer}>
          <a href="/"><img className={styles.logo} src={logo} alt="" /></a>
        </div>
        <div className={styles.menucontainer}>
        </div>
        <div className={styles.optcontainer}>
          <Toolbar 
            right={
              <React.Fragment>
                {/*
                <Dropdown 
                  optionLabel='name'
                  value={Translate.languages.find(p => p.code === this.state.storage?.languaje) ?? Translate.languages[0]}
                  className={`${styles.idioma}`}
                  valueTemplate={value => <>{value.code.toUpperCase()}</>}
                  itemTemplate={row => <><b>{row.code.toUpperCase()}</b> {row.name}</>}
                  onChange={e => Actions.LanguajeChanged(e.target.value.code)}
                  options={Translate.languages}
                />
                */}
                {/* NOTIFICACIONES */}
                <span className="p-overlay-badge">
                  <Button 
                    icon="pi pi-bell" 
                    className={`p-button-rounded ${(notificationUnreads > 0) ? `p-button-warning ${styles["notificaciones-on"]}` : 'p-button-success'} p-button-outlined`}
                    style={{ marginLeft: 15 }} 
                    onClick={e => {
                      let obj = e.target as any;
                      if (obj.tagName.toUpperCase() === "SPAN") obj = obj.parent; // tomo siempre el button
                      this.NotificacionPanel && this.NotificacionPanel.toggle(e, obj);
                    }}
                  />
                  {(notificationUnreads > 0) && <span className="p-badge p-badge-warning">{notificationUnreads}</span>}
                </span>
                <OverlayPanel 
                  ref={(el:OverlayPanel) => this.NotificacionPanel = el} 
                  dismissable 
                  className={`${styles["notificaciones-overlay"]} p-shadow-5`}
                  appendTo={(window as any).mainbody}
                >
                  <Notifications 
                    notificaciones={this.state.notificaciones ?? []}
                    onRefresh={() => this.checkNotificaciones(false)}
                  />
                </OverlayPanel>

                {/* PANEL DE USUARIO */}
                <Button 
                  //icon="pi pi-user" 
                  className="p-button-rounded p-button-info p-button-outlined" 
                  style={{ marginLeft: 15, padding: 0 }} 
                  onClick={e => {
                    let obj = e.target as any;
                    if (obj.tagName.toUpperCase() === "SPAN") obj = obj.parent; // tomo siempre el button
                    this.UserPanelShow && this.UserPanelShow(e, obj);
                  }}
                >
                  <img alt="Avatar" className={styles.avatar} src={userAvatar} width={38} height={38} /> 
                </Button>
                <UserInfoPanelComponent syncShow={e => this.UserPanelShow = e} />
              </React.Fragment>
            } 
          />
        </div>
      </div>
    );
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
